import { render, staticRenderFns } from "./CountryTab.vue?vue&type=template&id=5fe83c16&"
import script from "./CountryTab.vue?vue&type=script&lang=js&"
export * from "./CountryTab.vue?vue&type=script&lang=js&"
import style0 from "./CountryTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VIcon,VToolbar,VToolbarTitle})
